import cliente from './AxiosCliente'; 

const url = 'controller/usuario.php'; 

export default class {

    ingresar = (id, password, nombres, apellidos, email, tipoUsuario_id, direccion, comuna, telefono) => {

        let formData = new FormData();
        formData.append('funcion', 'ingresar');
        formData.append('id', id);
        formData.append('password', password);
        formData.append('nombres', nombres);
        formData.append('apellidos', apellidos);
        formData.append('email', email);
        formData.append('tipoUsuario_id', tipoUsuario_id);
        formData.append('direccion', direccion);
        formData.append('comuna', comuna);
        formData.append('telefono', telefono);

        let consulta =  cliente.post({url: url, data: formData})
        return consulta;
    }

    mostrar = (id) => {
        let idEnviar = id!==undefined && id!=="" ? id : "";

        let formData = new FormData();
        formData.append('funcion', 'mostrar')
        formData.append('id', idEnviar)
        
        let consulta =  cliente.post({url: url, data: formData})
        return consulta;
    }
    
    estudiantes = () => {
        let formData = new FormData();
        formData.append('funcion', 'estudiantes')
        
        let consulta =  cliente.post({url: url, data: formData})
        return consulta;
    }

    eliminar = (id) => {
        let formData = new FormData();
        formData.append('funcion', 'eliminar');
        formData.append('id', id);

        let consulta =  cliente.post({url: url, data: formData})
        return consulta;
    }


    editar = (id, password, nombres, apellidos, email, tipoUsuario_id, direccion, comuna, telefono) => {
        let passEnviar = password!==undefined && password!=="" ? password : "";
        let tipoEnviar = tipoUsuario_id!==undefined && tipoUsuario_id!=="" ? tipoUsuario_id : "";

        let formData = new FormData();
        formData.append('funcion', 'editar');
        formData.append('id', id);
        formData.append('password', passEnviar);
        formData.append('nombres', nombres);
        formData.append('apellidos', apellidos);
        formData.append('email', email);
        formData.append('tipoUsuario_id', tipoEnviar);
        formData.append('direccion', direccion);
        formData.append('comuna', comuna);
        formData.append('telefono', telefono);

        let consulta =  cliente.post({url: url, data: formData})
        return consulta;
    }



    editarPass = (id, pass, nueva) => {
        let formData = new FormData();
        formData.append('funcion', 'editarpass');
        formData.append('id', id);
        formData.append('password', pass);
        formData.append('nueva', nueva);

        let consulta =  cliente.post({url: url, data: formData})
        return consulta;
    }




}